import React from 'react'
import { CiSearch } from 'react-icons/ci';

const NewAdBar: React.FC = () => {
  return (
    <div className='w-full flex justify-between items-center text-[#555] font-medium font-Poppins'>
      <div className="w-[38%] relative ">
        <input 
          type="text" 
          className='w-full border border-[#CCC] border-solid outline-none text-[#555] placeholder:text-[#555] placeholder:font-medium placeholder:font-Poppins font-medium font-Poppins rounded-lg h-11 py-3 pl-10 text-sm bg-comPagBg'
          placeholder='Search'
        />
        <div className="absolute left-3 top-[11px]">
          <CiSearch size={22} className='text-[#000]'/>
        </div>
      </div>

      <div className="flex w-[30%] text-sm justify-between">
        <div className="border w-[49%] border-[#CCC] border-solid flex justify-center rounded-lg items-center h-11">
          Edit
        </div>
      
        <div 
          className="flex border justify-center border-[#CCC] border-solid rounded-lg items-center gap-1 w-[49%] cursor-pointer active:w-[90px] active:h-10 active:mb-1 active:mx-[3px] h-11" 
        >
          Review
        </div>
      </div>  
    </div>
  )
}

export default NewAdBar;